import { Inject, Injectable } from '@angular/core';
import { CplA48SubmissionDetail } from '../model/cpl-a48-submission-detail.model';
import { CplA48ParaReportRequest } from '../model/cpl-a48-para-report-reqest.model';
import { CplA48UserSubmissionDetail } from '../model/a48/cpl-a48-user-submission-detail.model';
import { HttpClient, HttpParams } from '@angular/common/http';
import { BaseApi, BASE_URL, DateHelpers } from '@edl-development/edl-common';
import { CplItemSubType } from '../model/enum/cpl-item-sub-type.enum';

@Injectable()
export class Act48Api extends BaseApi {
    constructor(
        @Inject(BASE_URL) private baseUri: string,
        private http: HttpClient
    ) {
        super();
    }

    getAct48Status(userCycleId: string) {
        return this.http.get(this.baseUri + '/a48/status/' + userCycleId);
    }

    ResubmitAct48Submission(details: CplA48SubmissionDetail) {
        return this.http.post(this.baseUri + '/a48/submission/resubmit', details);
    }

    ResubmitAct48UserSubmission(details: CplA48UserSubmissionDetail) {
        return this.http.post(this.baseUri + '/a48/submission/userdetails/resubmit', details);
    }

    OverrideAct48Submission(details: CplA48SubmissionDetail) {
        return this.http.post(this.baseUri + '/a48/submission/details', details);
    }

    SaveUserSubmissionDetails(value: CplA48UserSubmissionDetail) {
        return this.http.post(this.baseUri + '/a48/submission/userdetails', value);
    }

    getAct48UserSubmissionDetails(TypeId: number, Type: number) {
        return this.http.get(this.baseUri + `/a48/submission/userdetails/${TypeId}/${Type}`);
    }

    GetParaEducatorReport(details: CplA48ParaReportRequest){
        let params = new HttpParams()
            .append('offset', String(details.Offset))
            .append('limit', String(details.Limit))
            .append('type', <number>details.Type)
            .append('Perms', <number>details.Perms)
            .append('UserID', this.convertParam(details.UserID))
            .append('StartDate', DateHelpers.DateToShortDate(details.StartDate))
            .append('EndDate', DateHelpers.DateToShortDate(details.EndDate))
            .append('ShouldGetAll', details.ShouldGetAll)

        if (details.ItemSubType || details.ItemSubType !== CplItemSubType.NONE) {
            params = params.append('ItemSubType', <number>details.ItemSubType);
        }

        return this.http.get(this.baseUri + '/a48/report/paraeducator', { params });
    }
    getParaErrorSummary(userId: string, offset: number, limit: number, orderBy: string, ascending: boolean, searchBy: string) {
        const params = new HttpParams()
            .append('offset', String(offset))
            .append('limit', String(limit))
            .append('orderBy', this.convertParam(orderBy))
            .append('ascending', String(ascending))
            .append('searchBy', this.convertParam(searchBy));

        return this.http.get(this.baseUri + '/a48/GetParaErrors/' + userId, {
            params
        });
    }

    getAct48HoursDetailsReport(requestID: string) {
        return this.http.get(this.baseUri + '/a48/report/act48HoursDetails/' + requestID, {
            responseType: 'blob'
        })
    }
}